<ion-header>
  <ion-toolbar>
    <ion-title>Scan QR Code</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeDialog()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <div class="qr-header">
    <ion-item *ngIf="hasDevices">
      <ion-label>Camera</ion-label>
      <ion-select interface="alert" (ionChange)="onDeviceSelectChange($event.detail.value)"
        [value]="currentDevice?.deviceId">
        <ion-select-option value="" [selected]="!currentDevice">No Device Selected</ion-select-option>
        <ion-select-option *ngFor="let device of availableDevices" [value]="device.deviceId"
          [selected]="currentDevice && device?.deviceId === currentDevice.deviceId">{{ device?.label
          }}</ion-select-option>
      </ion-select>
    </ion-item>
  </div>

  <div class="qr-container">
    <div *ngIf="isLoading" class="qr-loading">
      <ion-spinner name="crescent"></ion-spinner>
    </div>
    <div class="qr-scanner" [ngClass]="{'loading' : isLoading}">
      <zxing-scanner #scanner [device]="currentDevice" (scanSuccess)="handleQrCodeResult($event)"
        [formats]="['QR_CODE']"></zxing-scanner>
    </div>
    <section class="qr-results" *ngIf="qrResultString">
      <div *ngIf="errorMessage == ''; else elseBlock">
        <h3 class="qr-results__reg">{{ data.registration }}</h3>
        <small class="qr-results__redirect">You will be redirected shortly...</small>
      </div>
      <ng-template #elseBlock>{{errorMessage}}</ng-template>
    </section>
  </div>

  <div *ngIf="!isLoading">
    <ng-container *ngIf="hasPermission === undefined">
      <ion-text color="medium">
        <h2>Waiting for permissions.</h2>
        <p>If your device does not have cameras, no permissions will be asked.</p>
      </ion-text>
    </ng-container>
    <ng-container *ngIf="hasPermission === false">
      <ion-text color="danger">
        <h2>You denied the camera permission, we can't scan anything without it.</h2>
      </ion-text>
    </ng-container>
    <ng-container *ngIf="hasDevices === undefined">
      <ion-text color="danger">
        <h2>Couldn't check for camera devices.</h2>
        <p>This may be caused by some security error in your browser.</p>
      </ion-text>
    </ng-container>
    <ng-container *ngIf="hasDevices === false">
      <ion-text color="danger">
        <h2>No camera devices were found.</h2>
        <p>I believe your device has no media devices attached to.</p>
      </ion-text>
    </ng-container>
    <ion-item lines="none">
      <ion-button fill="clear" (click)="toggleDetails()">{{showMetaDetails ? 'Hide' : 'Show'}} details</ion-button>
    </ion-item>
    <div class="qr-meta__content" [ngClass]="{'qr-meta__content--open': showMetaDetails}" *ngIf="showMetaDetails">
      <ion-list>
        <ion-item><ion-label>Scanner has camera(s)</ion-label><ion-note slot="end">{{ stateToEmoji(hasDevices)
            }}</ion-note></ion-item>
        <ion-item><ion-label>Scanner has permissions granted</ion-label><ion-note slot="end">{{
            stateToEmoji(hasPermission) }}</ion-note></ion-item>
        <ion-item><ion-label>QR Code data</ion-label><ion-note slot="end">{{ qrResultString }}</ion-note></ion-item>
      </ion-list>
      <ion-text color="medium">
        <p class="qr-meta__ng-version">Angular version: {{ ngVersion }}</p>
      </ion-text>
    </div>
  </div>

  <div class="d-message__actions ion-padding-top">
    <ion-button expand="block" *ngIf="showScanBtn" color="primary" (click)="startScanner()">
      Start Scanner
    </ion-button>
    <ion-button expand="block" color="medium" (click)="closeDialog()">
      Close/Cancel
    </ion-button>
  </div>
</ion-content>